import type { LinkProps } from "@remix-run/react";
import { Link as RmxLink, useLocation } from "@remix-run/react";
import type { FC } from 'react'

export const Link: FC<LinkProps> = ({ state, children, ...rest }) => {

    const location = useLocation()

    return <RmxLink {...rest} state={{ ...state, prevPath: `${location.pathname}${location.search}` }}>{children}</RmxLink>
}
